var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-main" },
    [
      !_vm.disableNavigation ? _c("RovinietaNavigation") : _vm._e(),
      _c("router-view", { on: { verifiedStatus: _vm.setVerifiedStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }